import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Image = ({ pics, picture, extraClass, imgClass, fit }) => {
  const Pics = pics.edges
  let res = Pics.filter(pic => pic.node.name === picture)

  return (
    <GatsbyImage
      fluid={res[0].node.childImageSharp.gatsbyImageData}
      image={getImage(res[0].node)}
      className={extraClass}
      imgClassName={imgClass}
      alt={picture}
    />
  );
}

export default Image